import { RemovePageButton } from './pageActions.js';
import styles from './settingsForm.module.css';

export interface NoSettingsPanelProps {
  pageLabel: string;
  /** One-sentence description of what this page does. */
  description: string;
}

/**
 * Shared shell for pages that have no per-page configuration. The
 * General tab's PagesPicker controls whether the page appears at all;
 * everything else about how the page behaves is interactive on the
 * page itself during morning meeting.
 */
export function NoSettingsPanel({ pageLabel, description }: NoSettingsPanelProps) {
  return (
    <div className={`glass glass--solid ${styles.panel}`}>
      <header className={styles.header}>
        <div className={styles.headerText}>
          <h2 className={styles.heading}>{pageLabel}</h2>
          <p className={styles.description}>{description}</p>
        </div>
        <RemovePageButton />
      </header>
      <p className={styles.hint}>
        No settings to configure here — this page just appears in morning meeting. Use “Remove page”
        (top right) to take it out, or drag it in the tab strip to reorder.
      </p>
    </div>
  );
}
